// API client used by the vendored TySoce (social operator) modules.
// Reads the EXISTING admin JWT used by the main app (`tylegn_admin_token`)
// so the user only signs in once at /admin/login.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "tylegn_admin_token";
const ADMIN_KEY = "tylegn_admin_user";

export const apiClient = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

// Kept for API compatibility with the vendored modules but not used — the
// main admin login owns the token now.
export const setAuthToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ADMIN_KEY);
  }
};

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 401) {
      setAuthToken(null);
      if (
        typeof window !== "undefined" &&
        !window.location.pathname.startsWith("/admin/login")
      ) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);
